import React from 'react';
import { G, Path, Svg } from 'react-native-svg';

interface IconProps {
  size?: number;
  color?: string;
}

export const SolarMagnifierBoldIcon: React.FC<IconProps> = ({ size = 32, color }) =>{
  const COLOR = color || '#FDFDFD';
  return(

    <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <G id="Magnifier">
        <Path
          d="M26.666 26.667L29.3327 29.3337"
          stroke={COLOR}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <Path
          d="M8.99935 4.36157C10.8624 3.28382 13.0255 2.66699 15.3327 2.66699C22.3283 2.66699 27.9993 8.33805 27.9993 15.3337C27.9993 22.3293 22.3283 28.0003 15.3327 28.0003C8.33708 28.0003 2.66602 22.3293 2.66602 15.3337C2.66602 13.0265 3.28285 10.8634 4.36059 9.00033"
          stroke={COLOR}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <G id="Vector_3">
          <Path
            d="M23.8039 17.1726C23.529 18.4445 22.9748 19.6126 22.2088 20.6093C21.4443 21.607 20.4597 22.4444 19.3024 23.0391C18.4319 23.4884 17.4755 23.7945 16.4643 23.9264C15.4534 24.0608 14.4503 24.0126 13.4931 23.8039C12.2213 23.529 11.0535 22.9749 10.0568 22.2091C9.0589 21.4445 8.22129 20.4596 7.62652 19.3021C7.17733 18.4317 6.87126 17.4755 6.73942 16.4645C6.60499 15.4534 6.65317 14.4502 6.86193 13.4929C7.40503 11.0025 9.03492 8.82308 11.3637 7.6265C12.2341 7.17728 13.1905 6.87119 14.2016 6.73938C15.2123 6.60503 16.2152 6.65317 17.1722 6.8618C19.7314 7.41486 21.8698 9.09815 23.039 11.3631C23.4883 12.2337 23.7945 13.1901 23.9264 14.2014C24.0608 15.2123 24.0126 16.2154 23.8039 17.1726Z"
            fill={COLOR}
          />
          <Path
            d="M10.9995 7.82566C12.2743 7.08826 13.7543 6.66621 15.3329 6.66621C20.1193 6.66621 23.9995 10.5464 23.9995 15.3329C23.9995 20.1193 20.1193 23.9995 15.3329 23.9995C10.5464 23.9995 6.66621 20.1193 6.66621 15.3329C6.66621 13.7543 7.08826 12.2743 7.82566 10.9995M21.4627 9.20419C22.505 10.2447 23.2957 11.565 23.7042 13.0898C24.9431 17.7132 22.1994 22.4654 17.576 23.7042C12.9526 24.9431 8.20035 22.1994 6.96152 17.576C5.72269 12.9526 8.46641 8.20035 13.0898 6.96152C14.6146 6.55296 16.1534 6.57756 17.5755 6.95991"
            stroke={COLOR}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </G>
      </G>
    </Svg>
  );
};
